import { reactive, ref } from 'vue';

import type { Message } from '../types';

export function createState() {
  const state = reactive({
    messages: ref<Message[]>([]),

    addMessage: (message: Message) => {
      state.messages = [];
      state.messages.push(message);
    },
  });

  return state;
}
